import React from 'react';
import useTheme from '../hooks/useTheme';
import { getSectionStyle } from '../utils/styleVariables';

interface SectionProps {
    children: React.ReactNode;
    style?: React.CSSProperties;
    id?: string;
    index?: number;
}

export const Section: React.FC<SectionProps> = ({ children, style = {}, id, index }) => {
    const { theme } = useTheme();
    const alternatingStyle = index !== undefined ? getSectionStyle(theme, index) : {};
    
    const sectionStyle: React.CSSProperties = {
        width: '100%',
        paddingTop: '72px',
        paddingBottom: '72px',
        paddingLeft: '20px',
        paddingRight: '20px',
        ...alternatingStyle,
        ...style,
    };

    const containerStyle: React.CSSProperties = {
        maxWidth: '1120px',
        margin: '0 auto',
        width: '100%',
    };

    return (
        <section id={id} style={sectionStyle} className="sectionPadding">
            <div style={containerStyle}>
                {children}
            </div>
        </section>
    );
};

